
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { TypedDataResult } from 'app/common/services/data-api/column-map';
import { ProjectTemplate } from 'app/shared/models';
import { map } from 'rxjs/operators';

@Injectable()
export class LookupProjectTemplateService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;
  private tableName: string = 'ProjectTemplates';

  public getTemplates(expand: string = null): Promise<TypedDataResult<ProjectTemplate>> {
    let url = `${this.BASE_URL}${this.tableName}?$count=true`;

    if (expand) {
      if (expand[0] !== '&') {
        expand = '&' + expand;
      }
      url += expand;
    }
    return this.http.get(url).pipe(map((r: any) => {
      return {
        total: r['@odata.count'],
        data: r.value as ProjectTemplate[]
      };
    })).toPromise();
  }
  public async findTemplate(
    projectId: number,
    projectTypeId: number,
    projectSubTypeId: number,
    drillDesignId: number,
    assetTeamId: number,
    constructionTypeid: number,
    functionId: number,
    operatingUnitId: number,
    divisionId: number,
    defaultStandardConfigurationId: number
  ): Promise<ProjectTemplate> {
    let fields: string[] = [];

    if (projectId) {
      fields.push('projectId=' + projectId);
    }
    if (projectTypeId) {
      fields.push('projectTypeId=' + projectTypeId);
    }
    if (projectSubTypeId) {
      fields.push('projectSubTypeId=' + projectSubTypeId);
    }
    if (drillDesignId) {
      fields.push('drillDesignId=' + drillDesignId);
    }
    if (assetTeamId) {
      fields.push('assetTeamId=' + assetTeamId);
    }
    if (constructionTypeid) {
      fields.push('constructionTypeid=' + constructionTypeid);
    }
    if (functionId) {
      fields.push('functionId=' + functionId);
    }
    if (operatingUnitId) {
      fields.push('operatingUnitId=' + operatingUnitId);
    }
    if (divisionId) {
      fields.push('divisionId=' + divisionId);
    }
    if (defaultStandardConfigurationId) {
      fields.push('defaultStandardConfigurationId=' + defaultStandardConfigurationId);
    }

    let url = `${this.BASE_URL}estimatetaskmapping/scheduletemplatefrommatrix?${fields.join('&')}`;

    return this.http
      .get(url).pipe(
        map(r => {
          return r as ProjectTemplate;
        }))
      .toPromise();
  }
}